/* @flow */
/* eslint no-unused-vars: 0 */

import React from "react"

class ProductSorting extends React.PureComponent {
  constructor(props) {
    super(props);

    this.setSortOption = this.setSortOption.bind(this);
    this.toggleOptionsDisplay = this.toggleOptionsDisplay.bind(this);

    this.state = {
      filteredSortOptions: [],
      selectedSort: props.sortDisplay,
      toggled: props.mobile
    };
  }

  componentDidMount() {
    this.setState({
      toggled: this.props.mobile
    });
  }

  componentWillReceiveProps() {
    const { guest, sortDisplay, sorting_options: sortingOptions } = this.props;

    const filteredSortOptions = !guest
      ? sortingOptions.filter(
          obj =>
            obj.value !== 'price_inclusive_vat.sort_asc' &&
            obj.value !== 'price_inclusive_vat.sort_desc'
        )
      : sortingOptions;

    this.setState({
      filteredSortOptions,
      selectedSort: sortDisplay
    });
  }

  setSortOption(index) {
    const { filteredSortOptions } = this.state;

    if (this.props.mobile) {
      this.setState({ toggled: true });
      this.props.toggle('display_sort_by');
    } else {
      this.setState({ toggled: false });
    }

    this.props.setSort(filteredSortOptions[index].value);
    this.setState({
      selectedSort: filteredSortOptions[index].display
    });
  }

  toggleOptionsDisplay() {
    const { toggled } = this.state;

    this.setState({
      toggled: !toggled
    });
  }

  render() {
    const { cross_white: close, checked, unchecked } = this.props.assets.icons;
    const { filteredSortOptions, toggled, selectedSort } = this.state;

    const options =
      toggled === true ? (
        <ul>
          {filteredSortOptions.map((option, index) => {
            return (
              <li
                key={index}
                onClick={() => {
                  this.setSortOption(index);
                }}
              >
                {option.display}

                {selectedSort === option.display ? (
                  <img
                    src={checked}
                    alt=""
                    height={20}
                    width={20}
                    className="visible-phone"
                    alt=""
                  />
                ) : (
                  <img
                    src={unchecked}
                    alt=""
                    height={20}
                    width={20}
                    className="visible-phone"
                    alt=""
                  />
                )}
              </li>
            );
          })}
        </ul>
      ) : (
        ''
      );
    return (
      <div className="products--sorting">
        <div className="sort--title">
          <span>Sort by</span>
          <img
            alt=""
            src={close}
            className="visible-phone"
            alt=""
            onClick={() => {
              this.props.toggle('display_sort_by');
            }}
            height={20}
            width={20}
          />
        </div>
        <div className="options">
          <div className="selected--option" onClick={this.toggleOptionsDisplay}>
            {this.state.selectedSort}
            <i className="icon-caret-down hidden-phone" />
          </div>
          {options}
        </div>
      </div>
    );
  }
}

export default ProductSorting;
